import React from 'react';
import PropTypes from 'prop-types';

import DropdownToggle from './dropdown-toggle';
import DropdownToggleWrapper from './dropdown-toggle-wrapper';

import './dropdown.scss';

const DropdownSelect = props => {
  const {
    label,
    alternateIcon,
    iconSize,
    menuAlign,
    items,
    selected,
    onSelect,
    multi,
    searchable,
    confirmPrompt,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
    styleType,
    formElement,
    name,
    onChange,
    errors,
    matchToggleWidth,
  } = props;

  return (
    <DropdownToggleWrapper
      items={items}
      menuAlign={menuAlign}
      selected={selected}
      multi={multi}
      searchable={searchable}
      confirmPrompt={confirmPrompt}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmText={confirmText}
      cancelText={cancelText}
      onSelect={onSelect}
      formElement={formElement}
      name={name}
      onChange={onChange}
      matchToggleWidth={matchToggleWidth}
    >
      <DropdownToggle
        label={label}
        alternateIcon={alternateIcon}
        iconSize={iconSize}
        styleType={styleType}
        errors={errors}
        formElement={formElement}
      />
    </DropdownToggleWrapper>
  );
};

DropdownSelect.propTypes = {
  label: PropTypes.string,
  alternateIcon: PropTypes.string,
  iconSize: PropTypes.number,
  menuAlign: PropTypes.oneOf(['right', 'left']),
  onSelect: PropTypes.func,
  multi: PropTypes.bool,
  searchable: PropTypes.bool,
  confirmPrompt: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  styleType: PropTypes.oneOf([null, 'bordered']),
  //	Form related props
  name: PropTypes.string,
  onChange: PropTypes.func,
};

DropdownSelect.defaultProps = {
  label: '',
  alternateIcon: null,
  iconSize: 12,
  menuAlign: 'right',
  onSelect: () => {},
  multi: false,
  searchable: false,
  confirmPrompt: false,
  onConfirm: null,
  onCancel: () => {},
  confirmText: 'Done',
  cancelText: 'Cancel',
  styleType: null,
  name: '',
  onChange: () => {},
};

export default DropdownSelect;
